import React from 'react';
import PropTypes from 'prop-types';

import TemplateAttachment from 'components/threepp/assessment/Answers/Attachments/Attachment/TemplateAttachment';
import './Attachments.scss';

import TemplateFieldUpdatesHOC from '../TemplateFieldUpdatesHOC';

export function TemplateAttachments(props) {
  const { question, assessmentId: templateId, recordId, disabled } = props;
  const attachments = question.attachmentValue;

  const renderAttachments = attachments.map(attachment => (
    <TemplateAttachment
      key={attachment.id}
      disabled={disabled}
      templateId={templateId}
      recordId={recordId}
      attachment={attachment}
      questionId={question.id}
    />
  ));
  return attachments.length ? <div className="rsa-attachments">{renderAttachments}</div> : null;
}

TemplateAttachments.propTypes = {
  // TODO: Fix this...
  // eslint-disable-next-line react/forbid-prop-types
  question: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  assessmentId: PropTypes.string.isRequired,
  recordId: PropTypes.string.isRequired
};

export default TemplateFieldUpdatesHOC(TemplateAttachments);
